import Jackpot from '@/components/Jackpot/Game/Jackpot';
import JackpotHistory from '@/components/Jackpot/History/JackpotHistory';
import SeoHead from '@/components/SEO/SeoHead';
import { useSubscription } from '@/utils/hooks/use-subscription';
import { ApiRequest } from '@/utils/axios';
import { notify } from '@/utils/notify';
import SuccessIcon from '@/components/Notifications/SuccessIcon';
import NotifyWrapper from '@/components/Notifications/NotifyWrapper';
import { inventoryStore } from '@/stores/inventory.store';
import { modalStore } from '@/stores/modal.store';

export default function Home() {
    const { uncacheSteamInventory } = inventoryStore((state) => state);
    const { toggleModal } = modalStore((state) => state);

    useSubscription('tradeReceived', async () => {
        const {
            data: {
                response: {
                    global: { appid },
                },
            },
        } = await ApiRequest.get('/settings/list');

        uncacheSteamInventory(appid, 2).then();
        toggleModal(false);

        notify(
            'success',
            <SuccessIcon />,
            <NotifyWrapper title={'Success'} text={`You successfully deposited your items!`} />
        );
    }).then();

    return (
        <>
            <SeoHead category="Jackpot" path="/" />
            <div className="flex flex-col gap-3 min-w-0 animate-fluent-fadeup">
                <Jackpot />
                <JackpotHistory />
            </div>
        </>
    );
}
